.ClearBoth {
    clear: both;
    height: 0px;
}

.HiddenPanel {
    display: none;
}

:host {
  display: block;
}

:host ion-card {
    margin: 0px;
    max-width: 260px;
    font-size: 1.0em;
}

:host ion-card-header {
    display: flex;
    flex-direction: row;
    padding-left: 12px;
    height: 50px;
    vertical-align: top;
}

:host ion-card-header img {
    display: inline-block;
    max-width: 20%;
    padding-top: 4px;
    padding-right: 10px;
    padding-bottom: 4px;
}

:host ion-card-title {
    display: inline-block;
    font-weight: bold;
    font-size: 0.8em;
    max-width: 75%;
    margin-top: 0px;
}

:host ion-card-content {
    padding: 0px;
    min-height: 400px;
}

:host ion-card-content div.MapView {
    width: 260px;
    height: 120px;
}

:host ion-card-content div.MapLocationName {
    position: absolute;
    top: 6px;
    right: 10px;
    font-weight: bold;
    color: #22007f;
}

:host ion-card-content div.CardBody {
    clear: both;
    border: 1px solid green;
}

:host ion-card-content div.NarrativeContent {
    padding: 12px;
    padding: 12px 12px 0px 12px;
    font-size: 0.8em;
}

:host ion-card-content div.PartnerTitle {
    font-weight: bold;
    padding-bottom: 10px;
}

:host ion-card-content div.CaseId {
    padding-top: 10px;
}

:host ion-card-content div.NarrativeContent ion-label {
    font-size: 0.7em;
}

:host ion-card-content div.ControlPalette {
    margin-bottom: 10px;
}

:host ion-card-content div.ControlPalette ion-button:first-of-type {
    position: relative;
    transform: scale(0.8);
    left: 0px;
}

:host ion-card-content div.ControlPalette ion-button.SocialButton {
    margin: 2px;
    transform: scale(1.0);
    float: right;
}

:host ion-card-content > .CardContent {
    height: 400px;
}
